import React, { useEffect, useRef, useState } from 'react'
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { logout } from '../../../Actions/Auth';
import '../MainHeader.css';
import styles from './CustomerHeader.module.css';
import StripePayment from '../../../StripePayment/StripePayment';
import PaymentHistory from '../../../StripePayment/PaymentHistory';
import { BiSolidWallet, BiSolidUser, BiMenuAltRight, BiCrosshair } from 'react-icons/bi';
import { Modal, Form, Input, Button, Checkbox, Popconfirm, ConfigProvider } from 'antd';
import BreatheEV_Logo from '../../../Images/logo.png';
import BreatheEV_Mobile_Logo from '../../../Images/logo-mobile.png';
import Image from 'react-bootstrap/Image';
import { Navigate } from 'react-router-dom';
import { BreathAPIs } from '../../../APIs/BreathAPIs';
import { setFutureEstimateAmount } from '../../../Actions/Auth'
import ApplePay from '../../../StripePayment/ApplePay';
import CustomPWAButton from '../Header/components/CustomPWAButton';
import  Badge  from 'react-bootstrap/Badge';
import { IoIosCloseCircleOutline } from "react-icons/io";
import { loadUser } from '../../../Actions/Auth';
import store from '../../../store';
import Helper from '../../../Utils/Helper';
import { IoMdArrowDropdown } from "react-icons/io";

const CustomerHeader = (props) => {

  const [historyModal, setHistoryModal] = useState(false);
  const [walletModal, setWalletModal] = useState(false);
  const [walletRechargeModal, setWalletRechargeModal] = useState(false);
  const [bookings, setBookings] = useState([])
  const [selectedPart, setSelectedPart] = useState('part1');


  const [userMenu, setUserMenu] = useState(false);
  const userMenuRef = useRef(null);

  const [paymentHistoryPageNumber, setPaymentHistoryPageNumber] = useState(1)

  const [mobileMenu, setMobileMenu] = useState(false);
  const mobileMenuRef = useRef(null);
  const [userNRBookings, setUserNRBookings] = useState([]);
  const [isloading, setIsLoading] = useState(false)
  const [permissions, setPermissions] = useState([])
  const dispatch = useDispatch()
  //   const getBookings = async () => {

  //     const res = await BreathAPIs.getBookings();
  //     setBookings(res.data);
  //     // console.log(res.data)
  //     console.log(bookings)

  // };

  // const setHistoryPagement

  const handlePartChange = (part) => {
    setSelectedPart(part);
  };

  const setFutureEstimate = async () => {
    try {
      const res = await BreathAPIs.getUpcomingBookings();
      let now = new Date()
      let futureBookings = res.data.filter((bk) => {
        return ((bk.bookingStatus === "Idle") || (new Date(bk.startTime) > now) || (new Date(bk.startTime) <= now && new Date(bk.endTime) >= now))
      })

      let totalFutureCost = 0;
      futureBookings.map((booking) => {
        totalFutureCost += booking.estimateAmount
      }, 0);
      dispatch(setFutureEstimateAmount(totalFutureCost))
    } catch (error) {
      console.log("")
    }


  }

  useEffect(() => {
    checkCustomerPermissions();
  }, []);

  const checkCustomerPermissions = () => {
    let permissionsVar =[];

    permissionsVar = Helper.checkCustomerPermissions(props.userGroups);
    setPermissions(permissionsVar);
    console.log("permissions", permissionsVar)
  }

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setUserMenu(false);
      }

      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target)) {
        setMobileMenu(false);
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, [userMenu, mobileMenu]);

  if (props?.showLocationSelector) {
    return <Navigate to='/location-selection' />;
  }

  const confirm = async()=>{
    const res = await BreathAPIs.updateProfile({isAutoPayEnabled: false})
    console.log('res',res)
    if(res.status === 200){
      store.dispatch(loadUser())
    }
    
  }
  const getUserCurrentBookings = async ()=>{
            setIsLoading(true)
            const res = await BreathAPIs.getUpcomingBookings()
            console.log(res)
            setUserNRBookings([])
            console.log("123",res.data.length)
            res.data.map((b)=>{
                if(b.user._id === props.userID ){ //&& b.nonReservable
                    console.log(b)
                    setUserNRBookings([b])
                }
  
            })
            setIsLoading(false)
        }

  return (
    <div className={'nav-header bottom-line'}>
      <div className='container nav'>
        <NavLink to="/" >
          <Image className={styles['logo-larger']} src={BreatheEV_Logo} alt="BreatheEV Logo" />
          <Image className={styles['logo-mobile']} src={BreatheEV_Mobile_Logo} alt="BreatheEV Logo" />
        </NavLink>
        {/* Start Larger screen menu */}
        <ul className={`navbar-nav ${styles['nav-larger']}`}>

          <li className="nav-item">
            <CustomPWAButton view='pc' />
          </li>

          {props.access.timeline && <li className="nav-item">
            <span onClick={() => { setWalletModal(!walletModal); setFutureEstimate(); getUserCurrentBookings() }}><BiSolidWallet /> $ {props.balance?.toFixed(2)}</span>
          </li>}

          <li className="nav-item">
            
                <NavLink className="nav-link" to="/" >
                  Dashboard
                </NavLink>
            
          </li>
          {props.access.timeline && <>
            <li className="nav-item">
              <NavLink className="nav-link" to="/timeline" >
                Charge
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/bookingHist">
                View Bookings
              </NavLink>
            </li>
          </>}
            <li className={userMenu ? "nav-item dropdown active" : "nav-item dropdown"} ref={userMenuRef}>
            <div className='dropdown-btn' onClick={() => { setUserMenu(!userMenu); }}><BiSolidUser /></div>
            <div className='dropdown-menu-holder' onClick={() => { setUserMenu(false); }}>
              <div className='menu-tip' />
              <div className='menu-profile' >
                <div className='menu-profile-icon'><BiSolidUser /></div>
                <div className='menu-profile-name'>{props.name}</div>
              </div>
              <ul>
                {
                  permissions.includes('userControl') &&
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/customerUserView">
                      Users
                    </NavLink>
                  </li>
                }
                {
                  permissions.includes('rateControll') &&
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/customerRateView">
                      Rates
                    </NavLink>
                  </li>
                }
                {
                  permissions.includes('chargerControl') &&
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/customerChargerView">
                      Charger View
                    </NavLink>
                  </li>
                }
                {
                  permissions.includes('bookingView') &&
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/customerBookingView">
                      Booking View
                    </NavLink>
                  </li>
                }
                <li className="nav-item">
                  <NavLink className="nav-link" to="/profile">
                    My Profile
                  </NavLink>
                </li>
                
                <li className="nav-item">
                  <NavLink onClick={props.logout} className="nav-link" to="/login">
                    Logout
                  </NavLink>
                </li>
              </ul>
            </div>
          </li> 
        </ul>
        {/* End Larger screen menu */}

        {/* Start Mobile screen menu */}
        <ul className={`navbar-nav ${styles['nav-mobile']}`}>
          <li className="nav-item">
            <CustomPWAButton view='mobile' />
          </li>

          {props.access.timeline && <li className="nav-item">
            <span onClick={() => { setWalletModal(!walletModal); setFutureEstimate(); getUserCurrentBookings() }}><BiSolidWallet /> $ {props.balance?.toFixed(2)}</span>
          </li>}

          <li className={mobileMenu ? "nav-item dropdown active" : "nav-item dropdown"} ref={mobileMenuRef}>
            <div className='dropdown-btn' onClick={() => { setMobileMenu(!mobileMenu); }}>
              {<BiMenuAltRight className={mobileMenu ? `${styles['icon-rotate']} ${styles['deg-180']}` : `${styles['icon-rotate']}`} />}
            </div>
            <div className='dropdown-menu-holder' onClick={() => { setMobileMenu(false); }}>
              <div className='menu-tip' />
              <div className='menu-profile' >
                <div className='menu-profile-icon'><BiSolidUser /></div>
                <div className='menu-profile-name'>{props.name}</div>
              </div>
              <ul>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/" >
                    Dashboard
                  </NavLink>
                </li>
                {props.access.timeline && <>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/timeline" >
                      Charge
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/bookingHist">
                      View Bookings
                    </NavLink>
                  </li>
                </>}

                {
                  permissions.includes('userControl') &&
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/customerUserView">
                      Users
                    </NavLink>
                  </li>
                }
                {
                  permissions.includes('rateControll') &&
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/customerRateView">
                      Rates
                    </NavLink>
                  </li>
                }
                 {
                  permissions.includes('chargerControl') &&
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/customerChargerView">
                      Charger View
                    </NavLink>
                  </li>
                }
                {
                  permissions.includes('bookingView') &&
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/customerBookingView">
                      Booking View
                    </NavLink>
                  </li>
                }
                <li className="nav-item">
                  <NavLink className="nav-link" to="/profile">
                    My Profile
                  </NavLink>
                </li>

                <li className="nav-item">
                  <NavLink onClick={props.logout} className="nav-link" to="/login">
                    Logout
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
        </ul>
        {/* End Mobile screen menu */}


      </div>
{/* {<button className='btn-balance-modal' key={'btn3'}>Disable Wallet Reload</button>} */}
{/* {<span className={styles.disableSpan}>Disable auto wallet reload <span><IoIosCloseCircle /></span></span>} */}
{/* {<span><IoIosCloseCircleOutline style={{color:'red', marginBottom: '2', fontSize: '15'}}/></span>} */}
      <Modal open={walletModal} onCancel={() => { setWalletModal(!walletModal) }}
        okText="Add Amount" onOk={() => { setWalletModal(!walletModal); setWalletRechargeModal(true) }}
        footer={
        [
        
        <button className='btn-balance-modal' key={'btn1'} onClick={() => { setHistoryModal(!historyModal) }}>History</button>,
        <button className='btn-balance-modal' key={'btn2'} onClick={() => { setWalletModal(!walletModal); setWalletRechargeModal(true) }}>{props.autopayProp ? "Update Payment" : "Add Amount"}</button>,
        ]
        }>
        {
           props.autopayProp && !isloading && //(userNRBookings.length === 0) &&
          <ConfigProvider theme={{
            token: {
              colorPrimary: '#18365E',
              colorBgContainer: '#ffffff',
              boxShadow: 'none'
            },
          }}>
            <Popconfirm
              title="Confirm"
              description="Do you want to disable auto wallet reload?"
              placement='bottom'
              onConfirm={confirm}
              cancelText='No'
              okText='Yes'
              disabled={(userNRBookings.length !== 0)}
            ><span className={`${styles.disableSpan} ${((userNRBookings.length !== 0)) ? styles.disable : ''}`} pill >
                <span >Disable Auto Wallet Reload
                </span>
              </span>
            </Popconfirm>
          </ConfigProvider>
        }
        <div className='balance-modal-view'>
          <div className='balance-block'>Balance<span>${props.balance?.toFixed(2)}</span></div>
          <div className='balance-block'>Locked Amount<span>${props.futureEstimate?.toFixed(2)}</span></div>
          {/* <div className='balance-block'>Overnight Credits<span>{props.availableNightChargeCount}/4</span></div> */}
        </div>
        
      </Modal>
      {walletRechargeModal && <Modal open={walletRechargeModal} onCancel={() => { setWalletRechargeModal(!walletRechargeModal) }} footer={null} style={{overflow:'hidden'}}>
        <StripePayment setWalletRechargeModal={setWalletRechargeModal} amountToAdd={10} autoPayProp={props.autoPayProp}/>
      
      </Modal>}
      {historyModal && <Modal open={historyModal} onCancel={() => { setHistoryModal(!historyModal); setPaymentHistoryPageNumber(1) }} footer={<Button onClick={() => { setHistoryModal(!historyModal); setPaymentHistoryPageNumber(1) }}>Cancel</Button>}>
        <PaymentHistory paymentHistoryPageNumber={paymentHistoryPageNumber} setPaymentHistoryPageNumber={setPaymentHistoryPageNumber}></PaymentHistory>
      </Modal>}

    </div>
  );
};

CustomerHeader.propTypes = {
  logout: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
  loading: PropTypes.bool,
  balance: PropTypes.number,
  name: PropTypes.string,
  jwt: PropTypes.string,
  futureEstimate: PropTypes.number,
  userID: PropTypes.string,
  showLocationSelector: PropTypes.bool,
  access: PropTypes.object,
  autopayProp: PropTypes.bool,
  userGroups: PropTypes.array,
  availableNightChargeCount: PropTypes.number,
}
const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
  loading: state.auth.loading,
  balance: state.auth && state.auth.user ? state.auth.user.wallet.coins : null,
  name: state.auth && state.auth.user ? state.auth.user.firstName : null,
  jwt: state.auth ? state.auth.token : null,
  location: state.auth ? state.auth.user.location : null,
  futureEstimate: state.auth.futureEstimate ? state.auth.futureEstimate : 0,
  userID: state.auth && state.auth.user ? state.auth.user._id : null,
  showLocationSelector: state.auth && state.auth.user ? state.auth.user.showLocationSelector : false,
  access: state.auth && state.auth.user ? state.auth.user.access : null,
  autopayProp: state.auth && state.auth.user ? state.auth.user.isAutoPayEnabled : false,
  userGroups: state.auth && state.auth.user ? state.auth.user.userGroups : [],
  availableNightChargeCount: state.auth && state.auth.user ? state.auth.user.availableNightCharging : 0,
});

export default connect(mapStateToProps, { logout })(CustomerHeader);